import { FC, useEffect } from "react";
import Config from "../../config/app.config.json";
import EnvConfig from "../../config/env.config.json";
import { PrivacyPolicy } from "../../components/privacy";
import { HelmetCust } from "../../components";
import { mapTemplatesToPage } from "../../utils/commonFunctions/mapTemplatesToPage";
import { pushTrackingEventsToGAAndFB } from "../../utils/commonFunctions/GaAndFb";
import { gaEventTypes, gaScreenNames } from "../../Types/GoogleAnalytics";
import { useAppSelector } from "../../app/hooks";

const getComponent = (key: string) => {
  switch (key) {
    case "Policies":
      return <PrivacyPolicy key={key} />;
    default:
      return null;
  }
};

export const Privacy: FC = () => {
  const enteries = mapTemplatesToPage(Config.Privacy);
  const { seoData } = useAppSelector(
    (state: any) => state?.strapi?.commonPage || {}
  );
  useEffect(() => {
    pushTrackingEventsToGAAndFB(gaEventTypes.event, gaEventTypes.page_view, {
      appName: EnvConfig.brand,
      screenName: gaScreenNames.privacy,
    });
  }, []);
  return (
    <>
      <HelmetCust helmetPageName={"privacy"} />
      {enteries.map((item: any) => getComponent(item.component))}
    </>
  );
};
